'use client'
import { useContext } from 'react'
import { UncrawlableLink } from 'components/UncrawlableLink'
import { mainProductConfig } from 'constants/mainProductConfig'
import { LayoutContext } from 'providers/LayoutProvider'
import { selectOverride } from './Typography'
import { INLINES } from '@contentful/rich-text-types'
import { _get } from 'utils/shared'

export function UncrawlableLinkClient({ node, styleOverride, variantOverride }) {
  const { linkHref, linkText, target } = _get(node, 'data.target.fields', {})
  const { state: { siteEnv } = {} } = useContext(LayoutContext)

  return (
    <UncrawlableLink
      href={linkHref}
      target={target}
      track={{
        list_name: 'Uncrawlable Link',
        click_text: `${
          mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
        } | ${linkHref}`,
        click_type: 'Uncrawlable Link Click',
        track_event: 'ui_click',
        href: linkHref,
      }}
      sx={selectOverride(INLINES.ASSET_HYPERLINK, styleOverride, 'sx')}
      variant={selectOverride(INLINES.ASSET_HYPERLINK, variantOverride, 'variant')}
      data-testid={`Uncrawlable-Link-${linkText}`}
      component="button"
      className={''}
    >
      {linkText}
    </UncrawlableLink>
  )
}
